import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.168 11.21h-.84l-1.18-4.715h2.138a.786.786 0 0 0 .785-.786v-.707A3.23 3.23 0 0 0 15.85 1.78H4.221A3.23 3.23 0 0 0 1 5.002v.707a.786.786 0 0 0 .786.786h2.357v3.143H1.786a.786.786 0 0 0-.786.785v8.643a.786.786 0 0 0 .786.786h1.61a2.734 2.734 0 0 0 5.461 0h7.15a2.735 2.735 0 0 0 5.422 0h.785a.786.786 0 0 0 .786-.786v-3.025a4.84 4.84 0 0 0-4.832-4.832M4.22 3.351H15.85a1.65 1.65 0 0 1 1.65 1.571H2.571a1.65 1.65 0 0 1 1.65-1.571M14.53 6.495l1.399 5.5-.173.848-1.902-2.357.291-.283a.789.789 0 1 0-1.116-1.115l-1.571 1.571a.784.784 0 0 0 0 1.116.786.786 0 0 0 1.116 0l.165-.165 2.592 3.237-.055.275h-5.154l-.33-1.163a1.67 1.67 0 0 0-1.571-1.194H5.714v-6.27zM2.571 11.209h1.572v1.572H2.57zm3.536 9.429a1.179 1.179 0 1 1 0-2.358 1.179 1.179 0 0 1 0 2.358m2.475-2.358a2.735 2.735 0 0 0-4.973.048.9.9 0 0 0-.252-.047h-.786v-3.93h5.634a.09.09 0 0 1 .079.056l1.1 3.874zm10.097 2.358a1.179 1.179 0 1 1 0-2.358 1.179 1.179 0 0 1 0 2.358m2.75-2.358h-.275a2.734 2.734 0 0 0-4.95 0H11.04l-.392-1.57h5.28a.786.786 0 0 0 .785-.63l.66-3.3h.786a3.26 3.26 0 0 1 3.269 3.261z"
    }, null, -1)
  ]))]))
}
export default { render: render }